<svg:g>

  <circle class="subduct" [attr.cx]="cx" [attr.cy]="cy" [attr.r]="r" [ngClass]="{'occupied': subduct.occupied}" />

  <text class="subduct-label" [ngClass]="{'occupied': subduct.occupied}" [attr.x]="cx" [attr.y]="cy"
    dominant-baseline="middle">{{i}}</text>
</svg:g>
